import { render, staticRenderFns } from "./DrawerAvatarImg.vue?vue&type=template&id=0ea8c36b&scoped=true&"
import script from "./DrawerAvatarImg.vue?vue&type=script&lang=js&"
export * from "./DrawerAvatarImg.vue?vue&type=script&lang=js&"
import style0 from "./DrawerAvatarImg.vue?vue&type=style&index=0&id=0ea8c36b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea8c36b",
  null
  
)

export default component.exports